<script>

import Checkbox from '../../../common/PrimeVue/Checkbox.vue'

export default {
    name: 'Calendar-settings-dialog-field',
    components: {Checkbox},
    props: {
        value: {},
        definition: {}
    },
    methods: {
        updateSetting(key, value) {
            this.$emit('update:settings', key, (value || false));
        }
    }
};
</script>

<template>
    <v-autocomplete-custom v-if="definition.component === 'v-autocomplete-custom'"
        :value="value"
        v-bind="definition.props"
        popup-used-in-modal
        @input="(val) => this.updateSetting(definition.name, val)"
    />
    <div class="mb-2" v-else>
        <checkbox
            binary
            :model-value="value"
            v-bind="definition.props"
            @input="(val) => this.updateSetting(definition.name, val)"
        />
        {{definition.props.label}}
    </div>
</template>
